import { Navigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import LoadingSpinner from '../common/LoadingSpinner'

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireSubscription?: boolean;
  activeStep?: number;
}

export const ProtectedRoute = ({ 
  children, 
  requireSubscription = false,
  activeStep = 0 
}: ProtectedRouteProps) => {
  const { user, isSubscribed, loading } = useAuth()
  
  // Only show loading spinner for protected routes
  if (loading) {
    return (
      <div className="min-h-screen bg-bg-primary flex items-center justify-center">
        <LoadingSpinner />
      </div>
    )
  }

  if (requireSubscription && activeStep === 2) {
    if (!user) {
      sessionStorage.setItem('returnPath', '/upload');
      return <Navigate to="/sign-in" />
    }

    if (!isSubscribed) {
      return <Navigate to="/profile" />
    }
  }

  return <>{children}</>
}